import { render, staticRenderFns } from "./AlarmCenter.vue?vue&type=template&id=35491e1e&scoped=true"
import script from "./AlarmCenter.vue?vue&type=script&lang=js"
export * from "./AlarmCenter.vue?vue&type=script&lang=js"
import style0 from "./AlarmCenter.vue?vue&type=style&index=0&id=35491e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35491e1e",
  null
  
)

export default component.exports